import {withTranslation} from "react-i18next";
import {
    ArrowRightOutlined,LeftOutlined
} from '@ant-design/icons';
import "../ceiba.scss";
import {Button} from 'antd';
import {history} from '_helpers/history'
import chiic from "assets/img/chiic.png";

import Headerbutton from "../../component/headerButton";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";

function StepCeibaFive(props) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t, i18n} =props;

    const saveAndContinue = () => {
        history.push("/admin/dashboard")
    }
    return (

        <div className={"containerStartCeibaTwo wrapper history"}>
            <div className={"insideCeiba boxed"}>
                <Headerbutton  saveAndContinue={saveAndContinue}  />
            </div>
            <div className={"container-history boxed"}>
                <img className={"character character--chiic"} src={chiic} alt={""} />
                <div className={"container-dialogue"}>
                    <div className={"dialogue-content-text"}>
                        <p className={"dialogue-text"}><strong>{t("hi")} {user.name ?? "" }</strong>!&nbsp;{t('ceiba.chicc1')}</p>
                        <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('ceiba.chicc2')}}></p>
                    </div>
                    <div className={"dialogue-buttons"}>
                        <div className="left margin-right-auto">
                            <Button
                              icon={<LeftOutlined />}
                              type={"link"}
                              onClick={() => props.goTo(5)}
                            >
                                {t("atras")}
                            </Button>
                        </div>
                        <div className="right">
                            <Button icon={<ArrowRightOutlined />}
                                    onClick={() => props.goTo(7)}
                                    type={"primary"}
                                    className="primaryButton"
                            >
                                {t("comoconsigo")}
                            </Button>
                        </div>
                    </div>
                    <p className={"dialogue-name"}>
                        <strong>CHIICH</strong>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default withTranslation()(StepCeibaFive);
